const CMS_ENDPOINT = "https://tfycms.replit.app/api/website/leads";

export async function sendLeadToCMS(data) {
  try {
    await fetch(CMS_ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        first_name:       data.first_name       || "",
        last_name:        data.last_name        || "",
        email:            data.email            || "",
        phone:            data.phone            || "",
        trip_type:        data.trip_type        || "contact",
        departure_city:   data.departure_city   || "",
        destination_city: data.destination_city || "",
        departure_date:   data.departure_date   || "",
        return_date:      data.return_date      || "",
        message:          data.message          || "",
        num_adults:       Number(data.num_adults)   || 1,
        num_children:     Number(data.num_children) || 0,
      }),
    });
  } catch (_) {
    // Fail silently — never block the user
  }
}
